import { trackEvent } from '@/utils/analytics';

/**
 * Track form submission events
 */
export const trackFormSubmission = (formName: string, success: boolean = true) => {
  trackEvent('form_submit', {
    form_name: formName,
    success: success
  });
};

/**
 * Track button clicks
 */
export const trackButtonClick = (buttonName: string, location?: string) => {
  trackEvent('button_click', {
    button_name: buttonName,
    location: location
  });
};

/**
 * Track file downloads
 */
export const trackFileDownload = (fileName: string, fileType: string) => {
  trackEvent('file_download', {
    file_name: fileName,
    file_type: fileType
  });
};

/**
 * Track job application events
 */
export const trackJobApplication = (action: string, position?: string, step?: string) => {
  trackEvent('job_application', {
    action: action,
    position: position,
    step: step
  });
};

/**
 * Track cookie consent events
 */
export const trackCookieConsent = (action: 'accept_all' | 'reject_all' | 'customize', preferences?: Record<string, boolean>) => {
  trackEvent('cookie_consent', {
    action: action,
    preferences: preferences
  });
};
